var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ToIntoing"},[_c('CustomHead',{attrs:{"srcName":"loading.png"}},[_c('div',{staticClass:"Transferring_in"},[_vm._v("系统匹配中…")]),_c('div',{staticClass:"Submitted"},[_vm._v("正在为您智能匹配产品…")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }